import { getTranslation } from "../locales";

export const validateDate = (dateObj, question, required) => {
  let validObj = dateObj && (dateObj.date || dateObj.time);
  if (validObj) {
    let invalidDate = dateObj.date == "Invalid Date";
    let emptyDate = dateObj.date == "";
    if (question.format.date && question.format.time) {
      // For date and time
      if (invalidDate || emptyDate || !dateObj.time || !dateObj.date) {
        return false;
      } else {
        return true;
      }
    } else if (question.format.date) {
      // For date only
      if (invalidDate || emptyDate) {
        return false;
      } else {
        return true;
      }
    } else if (question.format.time) {
      // For time only
      return dateObj.time ? true : false;
    }
  } else {
    return required ? false : true;
  }
};

export const displayDateMessage = (
  question,
  language,
  surveyExperienceType,
  currentQuestionValid,
  invalidQuestion,
  answers
) => {
  if (question.type === "datetime") {
    if (question.required) {
      // Indicates mandatory question
      if (invalidQuestion) {
        return getTranslation(language, "surveyTaker:requiredFieldError");
      } else if (surveyExperienceType === "guided" && !currentQuestionValid) {
        return getTranslation(language, "surveyTaker:requiredFieldError");
      } else {
        return "";
      }
    } else {
      if (
        !currentQuestionValid ||
        (invalidQuestion && question.format.date && question.format.time)
      ) {
        if (
          !answers[question.id] ||
          !answers[question.id].date ||
          !answers[question.id].time
        ) {
          return getTranslation(
            language,
            "surveyTaker:requiredFieldAllPartsError"
          );
        }
      }
    }
    return "";
  }
};
